import React from 'react'
import styled from 'styled-components'

import Option from '~/components/traffic-tickets/Option'
import SectionHeader from '~/components/Pages/SectionHeader'
import Spacer from '~/components/Spacer'

const QuestionContainer = styled.div`
  background-color: ${props => props.theme.colors.background.main};
  padding: 1rem;
  border-radius: 4px 4px 0 0;
`

const Questions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
`

const AnswerContainer = styled.div`
  padding: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: ${props => props.theme.fonts.avenirNextRegular};
  color: ${props => props.theme.colors.text.label};
  font-size: 1rem;
  line-height: 1.6875rem;
  min-height: 200px;
`

const QuestionModal = ({ faqs, selectedQuestion, selectedAnswer, onClick }) => {
  return (
    <>
      <QuestionContainer>
        <SectionHeader title="Frequently Asked Questions" />
        <Spacer desktop={40} mobile={20} />
        <Questions>
          {faqs.map(item => {
            const handleClick = () => onClick(item)
            return (
              <Option
                key={item[0]}
                isMobile
                isSelected={selectedQuestion && item[0] === selectedQuestion}
                onClick={handleClick}
              >
                {item[0]}
              </Option>
            )
          })}
        </Questions>
      </QuestionContainer>
      <AnswerContainer>
        {selectedQuestion ? selectedAnswer : 'Pick a Question'}
      </AnswerContainer>
    </>
  )
}

export default QuestionModal
